import { gql } from '@apollo/client';

export const FETCH_FACILITY_LOCATIONS = gql`
    query FetchFacilityLocations {
        system {
            companies {
                id
                name
                alias
                facilities {
                    latitude
                    longitude
                    name
                    id
                    region
                    type
                    isActive
                    alias
                    isOnline
                }
            }
        }
    }
`;
